module.exports = __webpack_public_path__ + "static/media/charity.d8e92feb.png";